import baseApi from './baseApi'
/**
 * 获取角色类型分页
 * @param {WebSiteID} data 
 * @param {Search} data 
 */
export function getRoleTypePage(data) {
    return baseApi({
        url: '/api/Role/Category/Page',
        method: 'post',
        data
    })
}
/**
 * 获取角色类型列表
 * @param {WebSiteID} data 
 * @param {Search} data 
 */
export function getRoleTypeList(data) {
    return baseApi({
        url: '/api/Role/Category/List',
        method: 'post',
        data
    })
}
/**
 * 获取角色类型列表
 * @param {search} data 
 */
export function getRoleType(data) {
    return baseApi({
        url: '/api/role/getRoleTypeList',
        method: 'get',
        params: data
    })
}
/**
 * 编辑角色类型
 * @param {search} data 
 */
export function addRoleType(data) {
    return baseApi({
        url: '/api/Role/Category/Add',
        method: 'post',
        data
    })
}
/**
 * 编辑角色类型
 * @param {search} data 
 */
export function editRoleType(data) {
    return baseApi({
        url: '/api/Role/Category/Edit',
        method: 'post',
        data
    })
}

/**
 * 删除角色类型
 * @param {ID} data 
 */
export function delRoleType(data) {
    return baseApi({
        url: '/api/Role/Category/Delete',
        method: 'get',
        params: data
    })
}
/**
 * 获取角色类型分页
 * @param {PageSize} data 
 * @param {PageIndex} data 
 * @param {WebSiteID} data 
 *  * @param {CategoryID} data 
 * @param {Search} data 
 */
export function getRolePage(data) {
    return baseApi({
        url: '/api/Role/Role/Page',
        method: 'post',
        data
    })
}
/**
 * 获取角色列表
 * @param {WebSiteID}  
 * @param {CategoryID}  
 * @param {search}  
 */
export function getRoleList(data) {
    return baseApi({
        url: '/api/Role/Role/List',
        method: 'get',
        params: data
    })
}
/**
 * 编辑角色类型
 * @param {search} data 
 */
export function addRole(data) {
    return baseApi({
        url: '/api/Role/Role/Add',
        method: 'post',
        data
    })
}
/**
 * 编辑角色类型
 * @param {search} data 
 */
export function editRole(data) {
    return baseApi({
        url: '/api/Role/Role/Edit',
        method: 'post',
        data
    })
}

/**
 * 锁定解锁
 * @param {ID} data 
 */
export function setRoleLockStatus(data) {
    return baseApi({
        url: '/api/Role/Role/Lock',
        method: 'get',
        params: data
    })
}
/**
 * 删除角色类型
 * @param {ID} data 
 */
export function delRole(data) {
    return baseApi({
        url: '/api/Role/Role/Delete',
        method: 'get',
        params: data
    })
}
/**
 * 获取角色权限菜单
 * @param {WebSiteID} 站点ID 
 * @param {RoleID} 角色ID 
 */
export function getAuthModule(data) {
    return baseApi({
        url: '/api/Role/Authority/Moduel',
        method: 'get',
        params: data
    })
}

/**
 * 获取权限按钮
 * @param {WebSiteID} 站点ID 
 * @param {RoleID} 角色ID 
 * @param {ModuleID} 角色ID 
 */
export function getAuthAction(data) {
    return baseApi({
        url: '/api/Role/Authority/Action',
        method: 'post',
        data
    })
}


/**
 * 获取部门信息
 * @param {WebSiteID} 站点ID 
 * @param {RoleID} 角色ID 
 */
export function getAuthDeptData(data) {
    return baseApi({
        url: '/api/Role/Authority/Org',
        method: 'get',
        params: data
    })
}

/**
 * 保存权限配置
 * @param {RoleID} 角色ID 
 * @param {Actions} 按钮配置项 
 * @param {Datas} 数据配置项
 * @param {Datas OrganizationID} 数据配置项-机构
 * @param {Datas Type} 数据配置项-类型
 * @param {Modules} 菜单配置项 
 */
export function saveAuthConfig(data) {
    return baseApi({
        url: '/api/Role/Authority/Save',
        method: 'post',
        data
    })
}

/**
 * 获取角色用户
 * @param {PageSize}  
 * @param {PageIndex}  
 * @param {RoleID} 角色ID 
 * @param {Search}  模糊查询
 */
export function getSelectPerson(data) {
    return baseApi({
        url: '/api/Role/People/List',
        method: 'post',
        data
    })
}

/**
 * 获取角色未授权人员
 * @param {PageSize}  
 * @param {PageIndex}  
 * @param {RoleID} 角色ID 
 * @param {Search}  模糊查询
 */
export function getNoSelectPerson(data) {
    return baseApi({
        url: '/api/Role/People/UserList',
        method: 'post',
        data
    })
}


/**
 * 设置角色对应的用户
 * @param {RoleID} 角色ID 
 * @param {UserIDs}  用户ID集合
 */
export function addPerson(data) {
    return baseApi({
        url: '/api/Role/People/Add',
        method: 'post',
        data
    })
}


/**
 * 移除角色对应的用户
 * @param {RoleID} 角色ID 
 * @param {UserIDs}  用户ID集合
 */
export function removePerson(data) {
    return baseApi({
        url: '/api/Role/People/Remove',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/areas/systemmanage/api/role.js